import React from "react";
import styles from "./Printable.scss";

export const Page = ({ children, id }) => {
    return (
        <div className={styles.page} id={id}>
            {children}
        </div>
    );
};
